import { forwardRef, useId, type TextareaHTMLAttributes } from "react";
import { HintMark } from "./Tooltip";
import "./textarea.css";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  /** Short explanation shown via the label info mark. */
  tooltip?: string;
};

/** Multi-line text field. Same surface tokens as Input; height grows with content. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, tooltip, className, rows = 4, id, ...rest },
  ref,
) {
  const generatedId = useId();
  const textareaId = id ?? (label ? generatedId : undefined);
  const field = (
    <textarea
      ref={ref}
      id={textareaId}
      rows={rows}
      className={["ui-textarea", className].filter(Boolean).join(" ")}
      {...rest}
    />
  );
  return label ? (
    <div className="ui-textarea-label">
      <span style={{ display: "inline-flex", alignItems: "center", gap: "var(--space-1)" }}>
        <label htmlFor={textareaId}>{label}</label>
        {tooltip ? <HintMark label={`About ${label}`} text={tooltip} /> : null}
      </span>
      {field}
    </div>
  ) : (
    field
  );
});
